import { BlankLayout } from '@/components/layouts';

export default {
  path: '/train',
  name: 'Train',
  component: BlankLayout,
  meta: { module: '培训' },
  children: [
    {
      path: '/train-map',
      name: 'Train.Map',
      component: () => import(/* webpackChunkName: 'train-map' */ '@/views/train/Map.vue'),
      meta: { title: '培训地图', hideBanner: true },
    },
    {
      path: '/train/list',
      name: 'Train.List',
      component: () => import(/* webpackChunkName: 'train-list' */ '@/views/train/TrainList.vue'),
      meta: { title: '培训列表', tags: '培训', hideBanner: true },
    },
    {
      path: '/train/list/search',
      name: 'Train.List.Search',
      component: () => import(/* webpackChunkName: 'train-list-search' */ '@/views/train/TrainListSearch.vue'),
      meta: { title: '培训列表-搜索', tags: '培训', hideBanner: true },
    },
    {
      path: '/train/list/mine',
      name: 'Train.List.Mine',
      component: () => import(/* webpackChunkName: 'train-details-mine' */ '@/views/train/TrainListMine.vue'),
      meta: { title: '我的培训', requiredLogin: true, tags: '培训' },
    },
    {
      path: '/train/:id',
      name: 'Train.Details',
      component: () => import(/* webpackChunkName: 'train-details' */ '@/views/train/TrainDetails.vue'),
      meta: { title: '培训详情', tags: '培训' },
    },
    {
      path: '/train/order/:id',
      name: 'Train.Order',
      component: () => import(/* webpackChunkName: 'train-order' */ '@/views/train/Order.vue'),
      meta: { title: '确认订单', hideBanner: true, requiredLogin: true },
    },
    {
      path: '/train/qrcode/:id',
      name: 'Train.QRCode',
      component: () => import(/* webpackChunkName: 'train-order' */ '@/views/train/QRCode.vue'),
      meta: {
        title: '课程二维码', requiredLogin: true, tags: '培训',
      },
    },
    {
      path: '/train/pay-result/:id',
      name: 'Train.Pay.Result',
      component: () => import(/* webpackChunkName: 'train-order' */ '@/views/train/PayResult.vue'),
      meta: { title: '支付成功', hideBanner: true, requiredLogin: true },
    },
  ],
};
